/**
 * Maps view-type identifiers (sent by the backend in `link` SSE events) to
 * Material Design icon names and Vuetify color tokens. The map is rdrive-flavoured
 * but harmless to keep — if the backend sends an unknown viewType the chip
 * falls back to defaultLinkStyle.
 */
export const linkStyleMap = {
  'issues':            { icon: 'mdi-map-marker-outline',       color: 'info' },
  'processes':         { icon: 'mdi-clipboard-check-outline',  color: 'success' },
  'plan-viewer':       { icon: 'mdi-floor-plan',               color: 'info' },
  'task-viewer':       { icon: 'mdi-chart-gantt',              color: 'warning' },
  'form-viewer':       { icon: 'mdi-file-document-outline',    color: 'secondary' },
  'b-i-m-viewer':      { icon: 'mdi-cube-outline',             color: 'purple' },
  'schedules':         { icon: 'mdi-calendar-clock',           color: 'warning' },
  'drawings':          { icon: 'mdi-pencil-ruler',             color: 'info' },
  'locations':         { icon: 'mdi-map-marker-outline',       color: 'teal' },
  'dashboards':        { icon: 'mdi-view-dashboard-outline',   color: 'primary' },
  'scheduled-report':  { icon: 'mdi-chart-bar',                color: 'indigo' },
  'documents':         { icon: 'mdi-folder-outline',           color: 'brown' },
  'task-set-profiles': { icon: 'mdi-file-tree',                color: 'deep-orange' },
  'file_download':     { icon: 'mdi-file-download-outline',    color: 'primary' },
}

export const defaultLinkStyle = { icon: 'mdi-open-in-new', color: 'primary' }
